export const TYPES = {
  Window: Symbol.for('Window'),
  AppConfig: Symbol.for('AppConfig'),
  CredentialsService: Symbol.for('CredentialsService'),
  NativeBridge: Symbol.for('NativeBridge'),
  EventsManager: Symbol.for('EventsManager'),
  NativeUiService: Symbol.for('NativeUiService'),
  AnalyticsService: Symbol.for('AnalyticsService'),
  TealiumAnalyticsService: Symbol.for('TealiumAnalyticsService'),
  AnalyticsServiceFactory: Symbol.for('Factory<AnalyticsService>'),
  SubscriptionService: Symbol.for('SubscriptionService'),
  StorageUtilityFactory: Symbol.for('Factory<StorageUtilityFactory>'),
  FeatureToggleService: Symbol.for('FeatureToggleService'),
  MonitorService: Symbol.for('MonitorService'),
  Monitor: Symbol.for('Monitor'),
  NotificationService: Symbol.for('NotificationService'),
  BrazeService: Symbol.for('BrazeService'),
  CampusService: Symbol.for('CampusService'),
  InAuthService: Symbol.for('InAuthService'),
  GeocodeService: Symbol.for('GeocodeService'),
  PageActionTimingService: Symbol.for('PageActionTimingService'),
  SentryService: Symbol.for('SentryService'),
  GrubTelemetryService: Symbol.for('GrubTelemetryService'),
};
